<template>
  <div class="c-class">
    <span class="c-class__header">知识点班级对比</span>
    <div class="c-class__bgc">
      <div class="class-compare">
        <!-- <div class="class-know"></div>
        <div class="class-weak"></div>
        <div class="class-over"></div> -->
        <div class="class-compare-data" id="class-compare-data"></div>
      </div>
    <EmptyLearning v-if="show"/>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import EmptyLearning from './empty-learning.vue';

export default {
  name: 'ClassCompare',
  props: {
    classContrast: {
      default: () => [],
      type: Array,
    },
  },
  components: {
    EmptyLearning,
  },
  data() {
    return {
      axis: [],
      show: false,
      contrastList: [],
      chartInstance: null,
    };
  },
  watch: {
    classContrast: {
      handler(val) {
        this.$nextTick(() => {
          if (!this.chartInstance) {
            this.initChart();
          }
          this.handleClassContrast(val);
        });
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.chartInstance) {
      window.removeEventListener('resize', this.handleResize);
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },
  methods: {
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    initChart() {
      const chartDom = document.getElementById('class-compare-data');
      if (chartDom) {
        this.chartInstance = echarts.init(chartDom);
        window.addEventListener('resize', this.handleResize);
      }
    },
    handleClassContrast(list = []) {
      if (!this.chartInstance) {
        this.initChart();
      }
      if (!this.chartInstance) {
        return;
      }
      if (!list.length) {
        this.show = true;
        this.contrastList = [];
        this.axis = [];
        if (this.chartInstance) {
          this.chartInstance.clear();
        }
        return;
      }
      this.contrastList = list;
      this.show = false;
      this.axis = list.map((item) => item.class_name || '--');
      this.initData();
    },
    initData() {
      if (!this.chartInstance || !this.contrastList.length) {
        return;
      }
      const categoryList = this.axis.map((name) => {
        if (name && name.length > 10) {
          return `${name.substring(0, 10)}...`;
        }
        return name;
      });
      const needsDataZoom = categoryList.length > 8;
      const option = {
        backgroundColor: 'transparent',
        legend: {
          data: ['测学知识点总数', '薄弱知识点总数', '攻克知识点总数'],
          textStyle: {
            color: '#FFFFFF',
          },
          top: 20,
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            if (!params || !params.length) {
              return '';
            }
            const [{ dataIndex }] = params;
            const className = this.axis[dataIndex] || '';
            const lines = params.map(({ marker, seriesName, value }) => (
              `${marker}${seriesName}：${value}`
            ));
            return [`${className}`, ...lines].join('<br/>');
          },
        },
        grid: {
          top: 90,
          left: 60,
          right: 40,
          bottom: needsDataZoom ? 100 : 60,
        },
        xAxis: {
          type: 'category',
          data: categoryList,
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            rotate: needsDataZoom ? 30 : 0,
            color: '#FFFFFF',
            formatter(value) {
              if (value && value.length > 10) {
                return `${value.substring(0, 10)}...`;
              }
              return value;
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.4)',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#FFFFFF',
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(255,255,255,0.2)',
            },
          },
        },
        dataZoom: needsDataZoom ? [
          {
            type: 'slider',
            start: 0,
            end: (8 / categoryList.length) * 100,
            height: 20,
            bottom: 40,
            textStyle: {
              color: '#FFFFFF',
            },
          },
          {
            type: 'inside',
          },
        ] : [],
        series: [
          {
            name: '测学知识点总数',
            type: 'bar',
            barMaxWidth: 28,
            data: this.contrastList.map((item) => item.tag_code_num),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00F1FF' },
                { offset: 0.72, color: '#48A6FF' },
                { offset: 1, color: '#8A4FFF' },
              ]),
              borderRadius: [6, 6, 0, 0],
            },
            label: {
              show: true,
              position: 'top',
              color: '#FFFFFF',
              fontSize: 12,
            },
          },
          {
            name: '薄弱知识点总数',
            type: 'bar',
            barMaxWidth: 28,
            data: this.contrastList.map((item) => item.weak_tag_code_num),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFD200' },
                { offset: 0.72, color: '#FF9A3C' },
                { offset: 1, color: '#FF4F4F' },
              ]),
              borderRadius: [6, 6, 0, 0],
            },
            label: {
              show: true,
              position: 'top',
              color: '#FFFFFF',
              fontSize: 12,
            },
          },
          {
            name: '攻克知识点总数',
            type: 'bar',
            barMaxWidth: 28,
            data: this.contrastList.map((item) => item.conquer_tag_code_num),
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#71F79F' },
                { offset: 0.72, color: '#1AC8ED' },
                { offset: 1, color: '#1C7CFF' },
              ]),
              borderRadius: [6, 6, 0, 0],
            },
            label: {
              show: true,
              position: 'top',
              color: '#FFFFFF',
              fontSize: 12,
            },
          },
        ],
      };
      this.chartInstance.setOption(option, true);
    },
    initKnow() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.class-know'));
      // 绘制图表
      myChart.setOption(
        {
          title: {
            text: '测学知识点数',
            top: 25,
            left: 30,
            textStyle: {
              fontSize: 16,
              color: '#FFFFFF',
              fontWeight: 500,
            },
          },
          tooltip: {
            trigger: 'axis',
          },
          grid: {
            top: 74,
            left: 70,
            bottom: 90,
          },
          xAxis: {
            type: 'category',
            data: this.axis,
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 30,
              textStyle: {
                color: '#fff',
                fontSize: '12',
              },
            },
            axisLine: {
              show: false,
            },
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: ['rgba(255, 255, 255, 0.3)'],
              },
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: '12',
              },
            },
          },
          series: [{
            data: this.contrastList.map((item) => item.tag_code_num),
            type: 'bar',
            barMaxWidth: 24,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00F1FF',
                }, {
                  offset: 0.72,
                  color: '#48A6FF',
                }, {
                  offset: 1,
                  color: '#8A4FFF',
                }]),
                label: {
                  formatter(params) {
                    return params.data;
                  },
                  show: true,
                  position: 'top',
                  textStyle: {
                    fontWeight: 500,
                    fontSize: '12',
                    color: '#fff',
                  },
                },
              },
            },
          }],
        },
      );
    },
    initWeak() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.class-weak'));
      // 绘制图表
      myChart.setOption(
        {
          title: {
            text: '测出薄弱知识点数',
            top: 25,
            left: 30,
            textStyle: {
              fontSize: 16,
              color: '#FFFFFF',
              fontWeight: 500,
            },
          },
          tooltip: {
            trigger: 'axis',
          },
          grid: {
            top: 74,
            left: 70,
            bottom: 90,
          },
          xAxis: {
            type: 'category',
            data: this.axis,
            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: '12',
              },
              interval: 0,
              rotate: 30,
            },
            axisLine: {
              show: false,
            },
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: ['rgba(255, 255, 255, 0.3)'],
              },
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: '12',
              },
            },
          },
          series: [{
            data: this.contrastList.map((item) => item.weak_tag_code_num),
            type: 'bar',
            barMaxWidth: 24,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00F1FF',
                }, {
                  offset: 0.72,
                  color: '#48A6FF',
                }, {
                  offset: 1,
                  color: '#8A4FFF',
                }]),
                label: {
                  formatter(params) {
                    return params.data;
                  },
                  show: true,
                  position: 'top',
                  textStyle: {
                    fontWeight: 500,
                    fontSize: '12',
                    color: '#fff',
                  },

                },
              },
            },
          }],
        },
      );
    },
    initOver() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.class-over'));
      // 绘制图表
      myChart.setOption(
        {
          title: {
            text: '攻克薄弱知识点数',
            top: 25,
            left: 30,
            textStyle: {
              fontSize: 16,
              color: '#FFFFFF',
              fontWeight: 500,
            },
          },
          tooltip: {
            trigger: 'axis',
          },
          grid: {
            top: 74,
            left: 70,
            bottom: 90,
          },
          xAxis: {
            type: 'category',
            data: this.axis,
            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: '12',
              },
              interval: 0,
              rotate: 30,
            },
            axisLine: {
              show: false,
            },
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: ['rgba(255, 255, 255, 0.3)'],
              },
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: '12',
              },
            },
          },
          series: [{
            data: this.contrastList.map((item) => item.conquer_tag_code_num),
            type: 'bar',
            barMaxWidth: 24,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#00F1FF',
                }, {
                  offset: 0.72,
                  color: '#48A6FF',
                }, {
                  offset: 1,
                  color: '#8A4FFF',
                }]),
                label: {
                  formatter(params) {
                    return params.data;
                  },
                  show: true,
                  position: 'top',
                  textStyle: {
                    fontWeight: 500,
                    fontSize: '12',
                    color: '#fff',
                  },

                },
              },
            },
          }],
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.c-class{
  box-sizing: border-box;
  margin-left:32px ;
   &__header {
     display: block;
    position: relative;
    font-size: 28px;
    font-weight: 500;
    text-indent: 1em;
    color: #E3E2FF;
    &::before {
      content: '';
      position: absolute;
      width: 27px;
      height: 27px;
      top: 9px;
      left: -8px;
      background: url('../../images/cockpit-icon.png') no-repeat center / contain;
    }
  }
    &__bgc{
    margin-top:30px ;
    position: relative;
    width: 1101px;
    height: 542px;
    background: linear-gradient(180deg, rgba(50, 191, 255, 0.4) 0%, rgba(107, 70, 252, 0.4) 100%);
    border-radius: 8px ;
    // opacity: 0.38;
    }
    .class-compare{
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      .class-know{
        flex: 1;
         width: 355px;
        height: 542px;
      }
      .class-over{
        flex: 1;

         width: 355px;
        height: 542px;
      }
      .class-weak{
        flex: 1;
         width: 355px;
        height: 542px;
      }
      .class-compare-data{
        flex: 1;
        width: 1101px;
        height: 542px;
      }
    }
}
</style>
